import { render } from "./PeripheralItem.vue?vue&type=template&id=00941542&scoped=true&ts=true"
import script from "./PeripheralItem.vue?vue&type=script&lang=ts"
export * from "./PeripheralItem.vue?vue&type=script&lang=ts"

import "./PeripheralItem.vue?vue&type=style&index=0&id=00941542&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00941542"],['__file',"src/components/PeripheralItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00941542"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00941542', __exports__)) {
    api.reload('00941542', __exports__)
  }
  
  module.hot.accept("./PeripheralItem.vue?vue&type=template&id=00941542&scoped=true&ts=true", () => {
    api.rerender('00941542', render)
  })

}


export default __exports__